import { BareButton } from '@calendly/ui/components/bare-button';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { useHasSeenNotification, useUserSessionLogout } from 'features/admin';
import PretendModeIcon from 'images/icons/pretend-mode-icon.svg';
const outerContainerIsPhoneCss = "o1exltj7";
const outerContainerCss = "olmv7su";
const OuterContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(outerContainerCss, {
    [outerContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const innerContainerCss = "i1xbj7me";
const InnerContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(innerContainerCss, props.className)} />;
});
const exitButtonCss = "e13ok3xy";
const ExitButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(exitButtonCss, props.className)} />);
export const PretendModeHeader = () => {
  const {
    data: {
      is_pretending: isPretending
    }
  } = useGetUserQuery();
  const [hasSeenNotification, setHasSeenNotification] = useHasSeenNotification();
  const [logout] = useUserSessionLogout('/users/pretendings');
  const onPretendExit = () => {
    if (hasSeenNotification) {
      setHasSeenNotification(false);
    }
    logout();
  };
  if (!isPretending) return null;
  return <OuterContainer>
      <InnerContainer>
        <PretendModeIcon width={16} height={16} />
        <BodyText color="#FFF" weight="bold">You are in pretend mode</BodyText>
        <ExitButton data-calendly-label="pretend-exit-button" onClick={onPretendExit}>
          Exit
        </ExitButton>
      </InnerContainer>
    </OuterContainer>;
};

require("./pretend_mode_header.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pretend_mode_header.js");